import { SearchParam } from "@hooks/useSearchParam";
import { logoutAnalyticsUser } from "./analytics/index.js";
import { AUTH_ORIGIN } from "./deployEnv.js";
import { StorageKey } from "./storageKeys.js";

const ORIGIN = globalThis.location?.origin;
const AUTH_TOKEN_KEY = StorageKey.AUTH_TOKEN;

/**
 * Gets a stored Auth Token for local storage.  We do this instead of cookies.
 */
export function getStoredAuthToken(): string | undefined {
  return localStorage.getItem(AUTH_TOKEN_KEY) || undefined;
}

/**
 * Sets an auth token in local storage.
 */
export function setStoredAuthToken(authToken: string) {
  localStorage.setItem(AUTH_TOKEN_KEY, authToken);
}

/**
 * Removes the auth token from local storage.
 */
export function removeStoredAuthToken() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

/**
 * URL for sending the user to authchemy to get authenticated, then come back.
 */
export function authchemyLoginRedirectUrl(redirectUrl: string) {
  return `${AUTH_ORIGIN}/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;
}

/**
 * URL for sending the user to authchemy to create an account, forwarding query params
 * so that we can measure referral info such as utm_source, utm_medium, utm_campaign, etc.
 */
export function authchemySignupRedirectUrl(redirectUrl: string) {
  return `${AUTH_ORIGIN}?redirectUrl=${encodeURIComponent(redirectUrl)}`;
}

/**
 * Redirects to authchemy for authentication, returning to the same URL
 */
export function redirectToAuthchemy(attempt?: number, redirectToLogin = false) {
  const url = new URL(window.location.href);

  if (attempt) {
    url.searchParams.set(SearchParam.RedirectAttempt, `${attempt}`);
  }

  // flag for HomePage to check if we're coming from authchemy
  url.searchParams.set("appRedir", "1");

  window.location.href = redirectToLogin
    ? authchemyLoginRedirectUrl(url.toString())
    : authchemySignupRedirectUrl(url.toString());
}

/**
 * Logs out the user, and redirects back to this app's homepage if they log in again.
 */
export function logOutFromAuthchemy() {
  removeStoredAuthToken();
  logoutAnalyticsUser();

  const redirectUrl = new URL(ORIGIN);
  redirectUrl.searchParams.set("appRedir", "1");
  const url = `${AUTH_ORIGIN}/logout?redirectUrl=${encodeURIComponent(
    redirectUrl.toString(),
  )}`;
  globalThis.location.href = url;
}
